import { motion } from 'framer-motion';

export function Process() {
  const steps = [
    {
      number: '01',
      title: 'Consult',
      description: 'We discuss your vision, needs, and budget to create the perfect signage solution for your business.',
      icon: 'ri-chat-3-line'
    },
    {
      number: '02',
      title: 'Design',
      description: 'Our creative team develops custom designs that align with your brand and capture attention.',
      icon: 'ri-palette-line'
    },
    {
      number: '03',
      title: 'Production',
      description: 'Using state-of-the-art equipment and premium materials, we bring your signage to life.',
      icon: 'ri-tools-line'
    },
    {
      number: '04',
      title: 'Install',
      description: 'Professional installation ensures your signage looks perfect and performs flawlessly.',
      icon: 'ri-checkbox-circle-line'
    }
  ];

  return (
    <section id="process" className="py-24 bg-gradient-to-br from-gray-900 to-gray-800 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-teal-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-500 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            How It <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-orange-400">Works</span>
          </h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            Our streamlined process ensures your project is completed on time and exceeds expectations
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="relative"
            >
              <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:border-teal-500/50 transition-all">
                <div className="text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-teal-400 to-orange-400 mb-4">
                  {step.number}
                </div>
                <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center mb-6">
                  <i className={`${step.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">{step.title}</h3>
                <p className="text-gray-300 text-sm leading-relaxed">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-gradient-to-r from-teal-500 to-orange-500"></div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}